module.exports = __webpack_public_path__ + "static/media/fa-regular-400.a0e3ac82.ttf";